module.exports = __webpack_public_path__ + "img/bwzyjp-currency-guide.15e9945d.png";